<div (click)="onMenuClick($event)"
  *ngIf="fsItemActionsList.length > 0">
  <button mat-button
    [matMenuTriggerFor]="menuActions">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menuActions="matMenu">
    <button mat-menu-item
      *ngFor="let itemAction of fsItemActionsList"
      (click)="onFsItemActionClick(itemAction)">{{itemAction.label | translate}}</button>
  </mat-menu>
</div>